import clsx from "clsx";
import { FC } from "react";

import { Close } from "@/assets/icons";
import styles from "./styles.scss";

export const FiltersChip: FC<{
  filtersCount: number;
  isMobile?: boolean;
  onFiltersClear: () => void;
}> = ({ filtersCount, isMobile, onFiltersClear }) => {
  if (!filtersCount) {
    return <div className={styles.filtersPlaceholder} />;
  }

  return (
    <div
      className={clsx(styles.filterChip, isMobile && styles.filterChipMobile)}
    >
      <p className={styles.filterAmountApplied}>
        {filtersCount} filter{filtersCount > 1 && "s"} applied
      </p>

      <div className={styles.deselectButton} onClick={onFiltersClear}>
        <Close />
      </div>
    </div>
  );
};
